import { useEffect, useMemo, useRef } from 'react';
import { useLocalStorage } from 'usehooks-ts';

/**
 * Hook to set/get from localStorage using reactive useLocalStorage, wrapped as a ref.
 *
 * This allows reactivity where localStorage listeners are setup, without requiring this as a dependency due to it being a ref
 */
export const useLocalStorageRef = <T>(key: string, defaultValue: T) => {
  const storageKey = useMemo(() => key, [key]);
  const storageDefaultValue = useMemo(() => defaultValue, [defaultValue]);
  const storedState = useLocalStorage<T>(storageKey, storageDefaultValue);

  const storedStateHandler = useMemo(
    () => ({
      getStoredValue: () => storedState[0],
      setStoredValue: storedState[1]
    }),
    [storedState]
  );

  const loggedInRef = useRef(storedStateHandler);

  useEffect(() => {
    loggedInRef.current = storedStateHandler;
  }, [storedStateHandler]);

  return loggedInRef;
};
